import React, { useState, useEffect } from 'react';
import { Code, Wrench, Database, Layers, Shield } from 'lucide-react';

const Skills = ({ data, language, translations }) => {
  const [animate, setAnimate] = useState(false);
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || { skills: 'Habilidades' };

  useEffect(() => {
    setAnimate(true);
  }, []);

  const renderSkillCategory = (title, skills, icon, color = 'var(--cyan-primary)') => (
    <div className="skill-category">
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        {icon}
        <h3 className="skill-category-title" style={{ color: 'var(--steel-bright)' }}>{title}</h3>
      </div>
      {skills && skills.map((skill, index) => (
        <div key={index} className="skill-item">
          <div className="skill-name">
            <span>{skill.name}</span>
            <span style={{ color }}>{skill.level}%</span>
          </div>
          <div className="skill-bar">
            <div 
              className="skill-progress" 
              style={{ 
                width: animate ? `${skill.level}%` : '0%',
                background: color !== 'var(--cyan-primary)' ? color : undefined
              }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="content-section">
      <h2 className="section-title">{t.skills}</h2>
      <div className="section-content">
        {/* Development Skills */}
        <h3 style={{ 
          color: 'var(--steel-bright)', 
          fontSize: '16px', 
          marginBottom: '20px',
          borderBottom: '1px solid var(--border-color)',
          paddingBottom: '10px'
        }}>
          💻 {language === 'en' ? 'Development' : 'Desarrollo'}
        </h3>
        <div className="skills-grid">
          {renderSkillCategory(
            language === 'en' ? 'Programming Languages' : 'Lenguajes de Programación', 
            profileData.skills?.languages,
            <Code size={20} color="var(--steel-dim)" />
          )}
          {renderSkillCategory(
            language === 'en' ? 'Frameworks' : 'Frameworks', 
            profileData.skills?.frameworks,
            <Layers size={20} color="var(--steel-dim)" />
          )}
        </div>

        {/* Security Skills */}
        <h3 style={{ 
          color: '#ff5f57', 
          fontSize: '16px', 
          marginTop: '40px',
          marginBottom: '20px',
          borderBottom: '1px solid rgba(255, 95, 87, 0.3)',
          paddingBottom: '10px'
        }}>
          🔴 {language === 'en' ? 'Red Team & Pentesting' : 'Red Team & Pentesting'}
        </h3>
        <div className="skills-grid" style={{ gridTemplateColumns: '1fr' }}>
          {renderSkillCategory(
            language === 'en' ? 'Offensive Tools' : 'Herramientas Ofensivas', 
            profileData.skills?.redteam,
            <Shield size={20} color="#ff5f57" />,
            '#ff5f57'
          )}
        </div>

        {/* Databases */}
        <h3 style={{ 
          color: 'var(--cyan-primary)', 
          fontSize: '16px', 
          marginTop: '40px',
          marginBottom: '20px',
          borderBottom: '1px solid var(--border-color)',
          paddingBottom: '10px'
        }}>
          🗄️ {language === 'en' ? 'Databases' : 'Bases de Datos'}
        </h3>
        <div className="skills-grid" style={{ gridTemplateColumns: '1fr' }}>
          {renderSkillCategory(
            '', 
            profileData.skills?.databases,
            <Database size={20} color="var(--steel-dim)" />
          )}
        </div>

        {/* Methodologies */}
        <div style={{ marginTop: '30px' }}>
          <h3 style={{ color: 'var(--steel-bright)', fontSize: '16px', marginBottom: '15px' }}>
            🎯 {language === 'en' ? 'Methodologies & Frameworks' : 'Metodologías & Frameworks'}
          </h3>
          <div className="tech-tags">
            {profileData.skills?.methodologies?.map((method, index) => {
              const isSecurityRelated = ['OWASP Top 10', 'MITRE ATT&CK', 'Pentesting', 'CTF', 'Bug Bounty'].includes(method);
              return (
                <span 
                  key={index} 
                  className="tech-tag" 
                  style={{ 
                    fontSize: '14px', 
                    padding: '8px 16px',
                    borderColor: isSecurityRelated ? 'var(--violet)' : undefined,
                    color: isSecurityRelated ? 'var(--violet)' : undefined
                  }}
                >
                  {method}
                </span>
              );
            })}
          </div>
        </div>

        {/* Languages */}
        <div style={{ marginTop: '30px' }}>
          <h3 style={{ color: 'var(--steel-bright)', fontSize: '16px', marginBottom: '15px' }}>
            🌐 {language === 'en' ? 'Languages' : 'Idiomas'}
          </h3>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            {profileData.languages?.map((lang, index) => (
              <div key={index} style={{ 
                background: 'var(--bg-tertiary)', 
                padding: '15px 25px', 
                borderRadius: '8px',
                border: '1px solid var(--border-color)'
              }}>
                <p style={{ color: 'var(--text-primary)', marginBottom: '5px' }}>{lang.name}</p>
                <p style={{ color: 'var(--cyan-primary)', fontSize: '14px' }}>{lang.level}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
